import React, { ReactNode } from 'react';

import { Alert } from '@consumer-frontend/shared-ui';

export type ErrorPropsT = {
  message: string;
  children?: ReactNode;
  className?: string;
  displaySupportText?: boolean;
};
export type ErrorT = React.FC<ErrorPropsT>;

export const Error: ErrorT = ({
  message,
  children,
  className,
  displaySupportText,
}) => {
  return (
    <div className={`cnu-error ${className || ''} col col-md-6 mx-auto`}>
      <Alert dismissible={false} variant="warning">{message}</Alert>
      <p className="support-message text-center mb-1">
        {children}
      </p>
      {displaySupportText && (
        <p className="support-message text-center">
          Please call our Customer Support Team at <a href="tel:8773922014">(877)&nbsp;392-2014</a> or try again later.
        </p>
      )}
    </div>
  );
};
